import { useCallback } from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { RaRecord, useUpdate } from 'react-admin';

import { BOResourceAll } from '@Common/types/bo_external/resources';

type SafeUpdateFn<Req extends object, Res extends RaRecord> = (
  resource: BOResourceAll,
  params: { id: number | string; data: Req; previousData?: Res },
) => Promise<Res>;

export function useUpdatePromise<Req extends object, Res extends RaRecord = RaRecord>(): [
  SafeUpdateFn<Req, Res>,
  { isLoading: boolean; isError: boolean },
] {
  const [update, { isLoading, isError }] = useUpdate();
  const safeUpdate = useCallback(
    async (
      resource: BOResourceAll,
      params: { id: number | string; data: Req; previousData?: Res },
    ) => (await update(resource, params, { returnPromise: true })) as Res,
    [update],
  );

  return [safeUpdate, { isLoading, isError }];
}
